import $ from 'jquery';
window.$ = $;
window.jQuery = $;
window.jQuery = window.$ = $;
import '/vendor/bootstrap/js/bootstrap.bundle.js';

// Dynamically load Bootstrap Datepicker only when needed
if (typeof document !== 'undefined') {
    const hasDatepicker = document.querySelector('.datepicker, [data-provide="datepicker"], input[data-date]');
    if (hasDatepicker) {
        import('/vendor/bootstrap-datepicker/js/bootstrap-datepicker.js')
            .catch(e => console.error('Error loading bootstrap-datepicker dynamically:', e));
    }
}


// Word Rotator
(function($) {
    'use strict';

    console.log('qwdqwd');
    const subtitles = document.querySelectorAll('.card-subtitle');
    subtitles.forEach((subtitle, index) => {
        setTimeout(() => {
            subtitle.classList.add('reveal-bounce'); // O 'reveal' para sin bounce
        }, 500 + (index * 200)); // Delay progresivo: 0.5s base + 0.2s por elemento para stagger
    });

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('reveal-bounce');
                observer.unobserve(entry.target);
            }
        });
    });
    subtitles.forEach(subtitle => observer.observe(subtitle));

}).apply(this, [jQuery]);
